import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { getAdSource } from "@/lib/adSource";

const NAMES = { facebook: "Facebook", instagram: "Instagram", tiktok: "TikTok" };
const STYLE = { facebook: "pink-gradient", instagram: "bg-gradient-to-br from-amber-400 via-pink-500 to-fuchsia-600", tiktok: "bg-gradient-to-br from-slate-900 via-rose-600 to-cyan-500" };

export function FacebookWelcome({ compact = false }) {
  const [bonus, setBonus] = useState(null);
  const src = getAdSource();
  const fromFb = !!NAMES[src];
  useEffect(() => {
    if (fromFb) api.get("/public/stats").then(({ data }) => setBonus(data.settings?.points_facebook_welcome ?? 0)).catch(() => setBonus(0));
  }, [fromFb]);
  if (!fromFb || bonus === null) return null;
  if (compact) return bonus > 0 && (
    <div data-testid="fb-welcome-register" data-source={src} className="flex items-center gap-2 p-3 rounded-xl bg-amber-50 border border-amber-200 text-sm text-amber-800">
      <Gift className="w-4 h-4 shrink-0" /> <span>Dein {NAMES[src]}-Willkommensbonus: <b>+{bonus} Punkte</b> direkt nach der Anmeldung!</span>
    </div>
  );
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-4" data-testid="fb-welcome-banner" data-source={src}>
      <div className={`relative overflow-hidden rounded-3xl ${STYLE[src]} text-white p-5 sm:p-6 shadow-xl shadow-rose-200 flex flex-col sm:flex-row sm:items-center gap-4 fade-up`}>
        <span className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-white/10" />
        <span className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center shrink-0"><Gift className="w-6 h-6" /></span>
        <div className="flex-1 min-w-0 relative">
          <p className="font-display text-xl sm:text-2xl font-extrabold leading-tight">Willkommen von {NAMES[src]}! 💖</p>
          <p className="text-white/90 text-sm sm:text-base mt-1">
            {bonus > 0 ? <>Schön, dass du da bist! Melde dich jetzt kostenlos an und sichere dir <b data-testid="fb-welcome-bonus">+{bonus} Willkommens-Punkte</b> als Startgeschenk.</> : "Schön, dass du da bist! Melde dich jetzt kostenlos an und sammle Punkte für tolle Geschenke."}
          </p>
        </div>
        <Link to="/registrieren" data-testid="fb-welcome-cta" className="relative inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full bg-white text-rose-600 font-bold shadow-md active:scale-95 transition-transform shrink-0">Jetzt mitmachen <ArrowRight className="w-4 h-4" /></Link>
      </div>
    </div>
  );
}
